import { render, staticRenderFns } from "./DocumentPreviewSection.vue?vue&type=template&id=b3e3792a&scoped=true&"
import script from "./DocumentPreviewSection.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreviewSection.vue?vue&type=style&index=0&id=b3e3792a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e3792a",
  null
  
)

export default component.exports